import axios from 'axios'
import { EventBus } from '@/functions/event-bus'

let activeRequests = 0

function toggleLoading(state) {
  EventBus.$emit('toggle-loading', state)
}
const publicAxios = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    'Content-Type': 'application/json',
     'Accept': 'application/json',
    'X-API-KEY': 'c333786c4acbe6cf110591592cc446cd8831d0df0f7eb35e55fa689155b163cf'
  },
  withCredentials: false // importante: rutas públicas
})

publicAxios.interceptors.request.use(config => {
  activeRequests++
  toggleLoading(true)
  return config
}, error => {
  activeRequests--
  if (activeRequests === 0) toggleLoading(false)
  return Promise.reject(error)
})

publicAxios.interceptors.response.use(
  response => {
    activeRequests--
    if (activeRequests === 0) toggleLoading(false)
    return response
  },
  error => {
    activeRequests--
    if (activeRequests === 0) toggleLoading(false)
    return Promise.reject(error)
  }
)

export default publicAxios
